import httpInstances from '@/api/axiosInstance';
import { parseFromToISO } from '@/utils/parseFromToISO';

export const queryApiById = async (queryId: string, from: string | undefined) => {
  from = parseFromToISO(from);
  return httpInstances.axiosInternalInstance
    .get(`/duck/${queryId}?mode=turbo&from=${from}`, { headers: { Accept: 'application/json' } })
    .then(response => {
      if (response.status === 200) {
        return [response.data];
      }
      throw new Error(`Query execution failed for ID '${queryId}' with status ${response.status}`);
    });
};

export const queryApiByIdString = async (queryId: string, from?: string) => {
  from = parseFromToISO(from);

  return httpInstances.axiosInternalInstance
    .get(`/duck/${queryId}?mode=turbo&from=${from}`, { headers: { Accept: 'text/csv' } })
    .then(response => {
      if (response.status === 200) {
        return response.data as string;
      }
      throw new Error(`Query execution failed for ID '${queryId}' with status ${response.status}`);
    });
};
